export default "__VITE_ASSET__PtNH4F7f__"